import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
var FontAwesome = require('react-fontawesome');

class ProductDescriptionDetail extends Component {

    render() {
        return (
            <div>
                <Row>
                    <Col xs={12} sm={6} md={6}>
                        <h3>Feature</h3>
                        <p style={{fontWeight:700}}><FontAwesome
                        className='super-crazy-colors'
                        name='check-circle'
                        size='2x'
                        style={{ color:'green',margin:3 }}
                        />
                        Lorem Ipsum คือ เนื้อหาจำลองแบบเรียบๆ ที่ใช้กันในธุรกิจงานพิมพ์หรืองานเรียงพิมพ์</p>
                        <p style={{fontWeight:700}}><FontAwesome
                        className='super-crazy-colors'
                        name='check-circle'
                        size='2x'
                        style={{ color:'green',margin:3 }}
                        />
                         Lorem Ipsum คือ เนื้อหาจำลองแบบเรียบๆ ที่ใช้กันในธุรกิจงานพิมพ์หรืองานเรียงพิมพ์</p>
                        <p style={{fontWeight:700}}><FontAwesome
                        className='super-crazy-colors'
                        name='check-circle'
                        size='2x'
                        style={{ color:'green',margin:3 }}
                        />
                         Lorem Ipsum คือ เนื้อหาจำลองแบบเรียบๆ ที่ใช้กันในธุรกิจงานพิมพ์หรืองานเรียงพิมพ์</p>
                    </Col>
                    <Col xs={12} sm={6} md={6}>
                        <p className="whitespace"></p>
                        <p style={{margin:3}} className="tcb-product-stdprice">ราคา 20 บาท ต่อ กิโลกรัม</p>
                        <p style={{margin:3}} className="tcb-product-price">ลดเหลือ 49 บาท (ลด 30%)</p>
                    </Col>
                </Row>
            </div>
        );
    }

}
export default ProductDescriptionDetail;



// WEBPACK FOOTER //
// ./src/components/product_description_detail.js